import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {accountEntitlementsStateSelector} from './account-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const accountEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('accountEntitlements');

export const accountEntitlementsActions = accountEntitlementsSlice.actions;
const accountEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.accountPage.tabs.entitlements.entitlements.cache;
export const accountEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.accountPage.tabs.entitlements.entitlements;
export const accountEntitlementsResultSelector = getCachedTableResultSelector(
    accountEntitlementsCacheSelector,
    accountEntitlementsStateSelector,
);
